/*
 * COUPle DE CŒUR – UX-Welle 1 (angelegt 16.09.2026)
 * 1. Konkretes Lieferdatum (UX-06) für alle [data-cdc-lieferdatum], auch nach dem Neuzeichnen der Warenkorb-Schublade.
 * 2. Mitlaufende Kaufleiste (UX-02) für [data-cdc-sticky].
 * Keine Abhängigkeiten, keine Tracking-Aufrufe.
 */
(function () {
  'use strict';

  /* ---------- 1. Lieferdatum ---------- */
  var JOURS = ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'];
  var MOIS = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'];

  function liste(text) {
    var set = {};
    String(text || '')
      .split(/[\s,;]+/)
      .forEach(function (d) {
        if (/^\d{4}-\d{2}-\d{2}$/.test(d)) set[d] = true;
      });
    return set;
  }

  // Heutiges Datum und Stunde am Versandort (Europe/Berlin) – unabhängig von der Zeitzone des Geräts.
  function jetztBerlin() {
    var teile = {};
    try {
      new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Europe/Berlin',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        hour12: false,
      })
        .formatToParts(new Date())
        .forEach(function (p) {
          teile[p.type] = p.value;
        });
    } catch (e) {
      var d = new Date();
      return { tag: Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()), stunde: d.getHours() };
    }
    return {
      tag: Date.UTC(+teile.year, +teile.month - 1, +teile.day),
      stunde: +teile.hour % 24,
    };
  }

  function iso(ms) {
    return new Date(ms).toISOString().slice(0, 10);
  }
  function wochentag(ms) {
    return new Date(ms).getUTCDay();
  }
  function istWerktag(ms, feiertage) {
    var w = wochentag(ms);
    return w !== 0 && w !== 6 && !feiertage[iso(ms)];
  }
  var TAG = 86400000;

  function plusWerktage(ms, n, feiertage) {
    var t = ms;
    var gezaehlt = 0;
    while (gezaehlt < n) {
      t += TAG;
      if (istWerktag(t, feiertage)) gezaehlt++;
    }
    return t;
  }

  function tagText(ms) {
    var d = new Date(ms);
    var tag = d.getUTCDate();
    return JOURS[d.getUTCDay()] + ' ' + (tag === 1 ? '1er' : tag);
  }

  function spanne(von, bis) {
    var a = new Date(von);
    var b = new Date(bis);
    if (von === bis) return 'le <strong>' + tagText(von) + ' ' + MOIS[a.getUTCMonth()] + '</strong>';
    if (a.getUTCMonth() === b.getUTCMonth()) {
      return 'entre le <strong>' + tagText(von) + '</strong> et le <strong>' + tagText(bis) + ' ' + MOIS[b.getUTCMonth()] + '</strong>';
    }
    return (
      'entre le <strong>' + tagText(von) + ' ' + MOIS[a.getUTCMonth()] + '</strong> et le <strong>' + tagText(bis) + ' ' + MOIS[b.getUTCMonth()] + '</strong>'
    );
  }

  function lieferdatum(el) {
    var ziel = el.querySelector('[data-cdc-lieferdatum-text]');
    if (!ziel) return;
    var schluss = parseInt(el.dataset.schluss, 10) || 14;
    var min = parseInt(el.dataset.min, 10) || 3;
    var max = Math.max(min, parseInt(el.dataset.max, 10) || min);
    var ftVersand = liste(el.dataset.feiertageVersand);
    var ftZustellung = liste(el.dataset.feiertageZustellung);

    var jetzt = jetztBerlin();
    var versand = jetzt.tag;
    var heuteMoeglich = istWerktag(versand, ftVersand) && jetzt.stunde < schluss;
    if (!heuteMoeglich) {
      do {
        versand += TAG;
      } while (!istWerktag(versand, ftVersand));
    }
    var von = plusWerktage(versand, min, ftZustellung);
    var bis = plusWerktage(versand, max, ftZustellung);

    var auftakt;
    if (heuteMoeglich) {
      auftakt = 'Commandez avant ' + schluss + ' h : reçu ';
    } else {
      auftakt = 'Commandez aujourd’hui : reçu ';
    }
    if (el.dataset.kontext === 'panier') {
      auftakt = heuteMoeglich ? 'Commandé avant ' + schluss + ' h, reçu ' : 'Livraison estimée ';
    }
    ziel.innerHTML = auftakt + spanne(von, bis) + '.';
    el.classList.add('is-berechnet');
  }

  function alleLieferdaten(wurzel) {
    (wurzel || document).querySelectorAll('[data-cdc-lieferdatum]:not(.is-berechnet)').forEach(lieferdatum);
  }

  /* ---------- 2. Mitlaufende Kaufleiste ---------- */
  function kaufleiste(leiste) {
    if (leiste.dataset.cdcBereit) return;
    if (leiste.closest('quick-add-modal, .quick-add-modal')) return;
    leiste.dataset.cdcBereit = '1';
    var sektion = leiste.dataset.section;
    var knopf = document.getElementById('ProductSubmitButton-' + sektion);
    if (!knopf) return;
    var footer = document.querySelector('.footer, footer');
    var preisQuelle = document.getElementById('price-' + sektion);
    var preisZiel = leiste.querySelector('[data-cdc-sticky-betrag]');
    var mobil = window.matchMedia('(max-width: 749px)');

    var knopfSichtbar = true;
    var footerSichtbar = false;
    var geplant = false;

    function aktualisieren() {
      var zeigen = mobil.matches && !knopfSichtbar && !footerSichtbar && !knopf.disabled;
      if (zeigen) leiste.hidden = false;
      leiste.classList.toggle('is-sichtbar', zeigen);
      leiste.setAttribute('aria-hidden', zeigen ? 'false' : 'true');
      leiste.querySelector('[data-cdc-sticky-knopf]').tabIndex = zeigen ? 0 : -1;
      document.body.classList.toggle('cdc-sticky-aktiv', zeigen);
      document.documentElement.classList.toggle('cdc-sticky-aktiv', zeigen);
    }

    // Lage per Scroll prüfen: Ein IntersectionObserver meldet nichts, wenn ein Sprung
    // (Anker, schnelles Wischen) den Knopf überspringt.
    function pruefen() {
      geplant = false;
      var hoehe = window.innerHeight || document.documentElement.clientHeight;
      var r = knopf.getBoundingClientRect();
      knopfSichtbar = r.bottom > 0 && r.top < hoehe - 8;
      if (footer) {
        var f = footer.getBoundingClientRect();
        footerSichtbar = f.top < hoehe;
      }
      aktualisieren();
    }
    function planen() {
      if (geplant) return;
      geplant = true;
      window.requestAnimationFrame(pruefen);
    }
    window.addEventListener('scroll', planen, { passive: true });
    window.addEventListener('resize', planen);
    // Bilder und nachgeladene Abschnitte verschieben den Knopf ohne Scroll-Ereignis
    window.addEventListener('load', planen);
    if ('ResizeObserver' in window) new ResizeObserver(planen).observe(document.body);
    var knopfBeobachter = { observe: planen, unobserve: function () {} };

    if (mobil.addEventListener) mobil.addEventListener('change', planen);

    leiste.querySelector('[data-cdc-sticky-knopf]').addEventListener('click', function () {
      var aktuell = document.getElementById('ProductSubmitButton-' + sektion) || knopf;
      if (aktuell.disabled || aktuell.getAttribute('aria-disabled') === 'true') {
        aktuell.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      aktuell.click();
    });

    // Preis und Verfügbarkeit nach einem Variantenwechsel übernehmen
    if (preisQuelle && preisZiel && 'MutationObserver' in window) {
      var uebernehmen = function () {
        var p = preisQuelle.querySelector('.price--on-sale')
          ? preisQuelle.querySelector('.price__sale .price-item--sale')
          : preisQuelle.querySelector('.price__regular .price-item--regular');
        var variante = leiste.querySelector('[data-cdc-sticky-variante]');
        var auswahl = document.querySelector('#MainProduct-' + sektion + ' variant-selects input:checked, #MainProduct-' + sektion + ' variant-selects select');
        if (p) preisZiel.textContent = p.textContent.trim();
        if (variante && auswahl) variante.textContent = auswahl.value;
        var neu = document.getElementById('ProductSubmitButton-' + sektion);
        if (neu && neu !== knopf) {
          knopfBeobachter.unobserve(knopf);
          knopf = neu;
          knopfBeobachter.observe(knopf);
        }
        aktualisieren();
      };
      new MutationObserver(uebernehmen).observe(preisQuelle, { childList: true, subtree: true, characterData: true });
    }
    planen();
  }

  function alleKaufleisten() {
    document.querySelectorAll('[data-cdc-sticky]').forEach(kaufleiste);
  }

  function start() {
    alleLieferdaten();
    alleKaufleisten();
    // Die Warenkorb-Schublade wird nach „Ajouter au panier“ neu gezeichnet – Datum dann neu setzen.
    var schublade = document.querySelector('cart-drawer');
    if (schublade && 'MutationObserver' in window) {
      new MutationObserver(function () {
        alleLieferdaten(schublade);
      }).observe(schublade, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
